'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

export const useAdminContext = () => {
  const pathname = usePathname()
  const isAdminContext = pathname.startsWith('/admin')

  // Add/remove admin context class to body
  useEffect(() => {
    if (isAdminContext) {
      document.body.classList.add('admin-context')
    } else {
      document.body.classList.remove('admin-context')
    }
    
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('admin-context')
    }
  }, [isAdminContext])

  return { isAdminContext }
}